import {
  PendingChip,
  RagChip,
} from "@poseidon/ui/components/RagChip";
import { WithDoc } from "@poseidon/firebase/components/WithDoc";

export const LazyActionChip = ({ docRef }) => {
  return (
    <WithDoc
      docRef={docRef}
      Component={ActionChip}
      fallbackValue={<PendingChip />}
    />
  );
};
const singularize = (input) => {
  return input.replace(/ies$/, "y").replace(/s$/, "");
};
const sentenceCase = (input) => {
  return input[0].toUpperCase() + input.substring(1);
};
const getActionForLabel = (actionFor, origin) => {
  if (actionFor) {
    if (typeof actionFor === "string") {
      return singularize(actionFor);
    } else if (actionFor?.parent?.id) {
      return singularize(actionFor?.parent?.id);
    }
  } else if (origin) {
    return singularize(origin);
  }
  return "unknown";
};
export const ActionChip = ({ data: { state, actionFor, origin } }) => {
  if ("complete" === state) {
    return <RagChip color="green" label="Complete" />;
  }
  if ("pendingApproval" === state) {
    return <RagChip color="orange" label="Pending Approval" />;
  }
  const actionForType = sentenceCase(getActionForLabel(actionFor, origin));

  return <RagChip color="red" label={`Action Required (${actionForType})`} />;
};

export const PepStatusChip = ({ data: { pepStatus } }) => {
  if ("yes" === pepStatus) {
    return <RagChip color="red" label="Yes" />;
  }
  if ("no" === pepStatus) {
    return <RagChip color="green" label="No" />;
  }
  return <RagChip label="Pending" />;
};

export const ApplicationSummaryActionChip = ({ state }) => {
  if ("complete" === state) {
    return <RagChip color="green" label="Complete" />;
  }
  if ("pendingApproval" === state) {
    return <RagChip color="orange" label="Pending Approval" />;
  }
  return <RagChip color="red" label={`Action Required`} />;
};
